import React from 'react';

export const YoutubeIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5285_4470)">
        <path
          d="M18.1674 6.66675C18.1674 6.66675 18.0046 5.51766 17.5033 5.0131C16.8686 4.34904 16.1589 4.34578 15.8334 4.30672C13.5027 4.13745 10.0033 4.13745 10.0033 4.13745H9.99683C9.99683 4.13745 6.49748 4.13745 4.16675 4.30672C3.84123 4.34578 3.13159 4.34904 2.49683 5.0131C1.99552 5.51766 1.83602 6.66675 1.83602 6.66675C1.83602 6.66675 1.66675 8.01766 1.66675 9.36532V10.6283C1.66675 11.976 1.83276 13.3269 1.83276 13.3269C1.83276 13.3269 1.99552 14.476 2.49357 14.9806C3.12834 15.6446 3.96167 15.6218 4.33276 15.6934C5.6674 15.8204 10.0001 15.8595 10.0001 15.8595C10.0001 15.8595 13.5027 15.8529 15.8334 15.6869C16.1589 15.6479 16.8686 15.6446 17.5033 14.9806C18.0046 14.476 18.1674 13.3269 18.1674 13.3269C18.1674 13.3269 18.3334 11.9792 18.3334 10.6283V9.36532C18.3334 8.01766 18.1674 6.66675 18.1674 6.66675ZM8.27808 12.1615V7.47729L12.78 9.82756L8.27808 12.1615Z"
          fill="#9075D1"
        />
      </g>
      <defs>
        <clipPath id="clip0_5285_4470">
          <rect
            width="16.6667"
            height="16.6667"
            fill="white"
            transform="translate(1.66675 1.66669)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
